import { useEffect, useRef, useState } from "react"

//PrimeReact
import { Dialog } from "primereact/dialog"
import { Password } from "primereact/password"
import { Button } from "primereact/button"

//Styles
import myStyles from "../../../../styles/TwoFA.module.css"

export default function RefreshLogin({ onHide }) {
  const [password, setPassword] = useState("")
  const inputRef = useRef(null)

  return (
    <Dialog
      header="Please re-enter your password to continue"
      visible={true}
      className={myStyles.refreshLoginDialog}
      onHide={() => {
        onHide()
      }}
      onShow={() => {
        inputRef.current?.focus()
      }}
      closable={false}
    >
      <Password
        inputRef={inputRef}
        value={password}
        feedback={false}
        onChange={(e) => {
          setPassword(e.target.value)
        }}
        className={myStyles.refreshLoginPassword}
      />
      <div className={myStyles.refreshLoginButtonContainer}>
        <Button
          label="Submit"
          onClick={() => onHide(password)}
          disabled={!password}
        />
        <Button label="Cancel" onClick={onHide} />
      </div>
    </Dialog>
  )
}
